module.exports = __webpack_public_path__ + "static/media/customer-couch.b86f91e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/customer-couch.png
// module id = 288
// module chunks = 0